import React from 'react';

const LinePhone = ({className}) => (
  <svg className={className} viewBox="0 0 148 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path style={{fillRule: "evenodd", clipRule: "evenodd", }} d="M2.76094 -5.5e-05H145.238C146.766 -5.5e-05 148 1.11753 148 2.49988C148 3.88244 146.766 5.00001 145.238 5.00001H2.76094C1.23432 5.00001 0 3.88244 0 2.49988C0 1.11753 1.23432 -5.5e-05 2.76094 -5.5e-05Z" />
  </svg>
);

export default LinePhone;
